/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = CheckedIn
 *
 * 1 = CheckedOut
 *
 * 2 = Closed
 */
export enum DigitalWipTabTypeFilterEnum {
  CheckedIn = 0,
  CheckedOut = 1,
  Closed = 2,
}
